// import Link from "next/link";
// export { Link };

import React from "react";
import { cn } from "@yardzen/next-client-util";

export const Link = React.forwardRef<
  HTMLAnchorElement,
  {
    children: React.ReactNode;
    href: string;
    variant?: "default" | "outline" | "button";
  } & React.AnchorHTMLAttributes<HTMLAnchorElement>
>(({ children, href, className, variant = "default", ...props }, ref) => {
  return (
    <a
      href={href}
      ref={ref}
      className={cn(
        {
          "text-black-elderberry hover:text-black-elderberry/90  duration transition-all":
            variant === "default",
          "border-black-elderberry text-black-elderberry hover:bg-black-elderberry/10 shadow-douglas-fir focus:ring-douglas-fir rounded-full  border bg-transparent px-6 py-2 transition-all duration-300 ease-in-out focus:shadow-lg focus:outline-none focus:ring-2":
            variant === "outline",
          "shadow-douglas-fir focus:ring-do`uglas-fir bg-black-elderberry hover:bg-black-elderberry/90 rounded-full border border-transparent px-6 py-2 text-white transition-all duration-300 ease-in-out focus:shadow-lg focus:outline-none focus:ring-2":
            variant === "button",
        },
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
});

Link.displayName = "Link";
